<template>
  <div class="">
    <h3 class="font-bold my-3">ویژگی ها</h3>

    <div class="" v-for="(componentsProp, key) in component.props" :key="generateRandomString">
      <div class="my-2" v-if="component.rawProps[key].type === Boolean">
        <div class="custom-control custom-switch">
          <input @click="setProp" :data-key="key" :checked="component.props[key] === true"
                 :value="component.props[key] == true ? false : true" type="checkbox"
                 class="custom-control-input" :id="`${component.id}-${key}`">
          <label class="custom-control-label" :for="`${component.id}-${key}`">{{ key }}</label>
        </div>
      </div>
      <div class="my-2" v-if="component.rawProps[key].optionType === 'static-form'">
        <hr>

        <static-form-manager :component="component" :propKey="key"/>

        <hr>


      </div>
      <div class="my-2" v-if="component.rawProps[key].options !== undefined">
        <label class="block text-sm font-medium text-slate-700">{{ key }}</label>
        <select class="custom-select" v-model="component.props[key]">
          <option v-for="option in component.rawProps[key].options" :value="option">{{ option }}</option>
        </select>
      </div>


      <div class="my-1"
           v-else-if="component.rawProps[key].options == undefined && component.rawProps[key].type !== Boolean && component.rawProps[key].optionType == undefined ">
        <label class="block text-sm font-medium text-slate-700">{{ key }}</label>
        <input type="text" @keyup="setProp" :value="component.props[key]" :data-key="key" class="form-control">


        <div class="" v-if="this.component.detail.tag.name =='A' && key == 'href' ">

          <setup-router-link class="my-2" :component="component"/>

        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {generateRandomString, resolveSelectPropValue, setComponentPropValues} from "@/store/Modules/Site";
import SetupRouterLink from "@/components/ComponentSettingComponents/SetupRouterLink.vue";
import StaticFormManager from "@/components/ComponentSettingComponents/StaticFormManager/StaticFormManager.vue";

export default {
  name: "ComponentPropManager",
  components: {StaticFormManager, SetupRouterLink},
  props: {
    component: {}
  },
  computed: {
    generateRandomString,
  },
  watch: {
    'component.id': {
      immediate: true,
      handler() {
        this.normalizeSelectProps()
      }
    },
    'component.rawProps': {
      deep: true,
      handler() {
        this.normalizeSelectProps()
      }
    }
  },
  methods: {
    setComponentPropValues,
    normalizeSelectProps() {
      const rawProps = this.component?.rawProps
      const props = this.component?.props
      if (!rawProps || !props) return
      Object.keys(props).forEach((key) => {
        if (rawProps[key] == null) return
        props[key] = resolveSelectPropValue(props[key], rawProps[key])
      })
    },
    async setProp(event) {
      const value = event.target.value;
      const key = event.target.getAttribute('data-key');
      const componentPath = await this.$store.dispatch('Site/findComponentPath', this.component.id)
      let component = await this.$store.dispatch('Site/pathToComponent', {componentPath})
      component.props[key] = value
      this.component.props = this.setComponentPropValues(component.props, component)
    },
  }
}
</script>

<style scoped>

</style>